import React from "react";
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Fab from '@material-ui/core/Fab';
import AppsIcon from '@material-ui/icons/Apps';
import List from '@material-ui/core/List';
import ModalMenuList from './ModalMenuList';
import { menusItem } from '../domain/menus';
import HomeIcon from '@material-ui/icons/Home';
import CheckIcon from '@material-ui/icons/Check';
import CloudIcon from '@material-ui/icons/Cloud';
import AddIcon from '@material-ui/icons/Add';
import ListItem, { ListItemProps } from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Collapse from '@material-ui/core/Collapse';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import PersonIcon from '@material-ui/icons/Person';
import ContactMailIcon from '@material-ui/icons/ContactMail';


const menuLists = menusItem.map(menu => {
  let iconElement = <CheckIcon />;
  if (menu.icon === 'CheckIcon') iconElement = <CheckIcon />;
  if (menu.icon === 'CloudIcon') iconElement = <CloudIcon />;
  if (menu.icon === 'AddIcon') iconElement = <AddIcon />;

  return {
    anchor: menu.anchor,
    name: menu.name,
    isDisplayMenu: menu.isDisplayMenu,
    icon: iconElement,
  }
});

const ListItemLink = (props: ListItemProps<'a', { button?: true }>) => {
    return <ListItem button component="a" {...props} />;
  }

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    paper: {
      position: 'absolute',
      border: '2px solid #000',
      boxShadow: theme.shadows[5],
      width: '80%',
      top: '20%',
      left: '10%',
      backgroundColor: theme.palette.background.paper,
    },
    modalOpenButton: {
      position: 'absolute',
      top: '85%',
      right: '10%',
      // eslint-disable-next-line
      ['@media (min-width:780px)']: {
        display: 'none',
      }
    },
    root: {
      width: '100%',
      maxWidth: 360,
      backgroundColor: theme.palette.background.paper,
    },
    nested: {
      paddingLeft: theme.spacing(4),
    },
  }),
);


const ModalMenu: React.FC = () => {
  const classes = useStyles();

  const [open, setOpen] = React.useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };


  const [listOpen, setListOpen] = React.useState(true);

  const handleClick = () => {
    setListOpen(!listOpen);
  };


  return (
    <div>
      <Modal
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        open={open}
        onClose={handleClose}
      >
        <div className={classes.paper}>
          <List
            component="nav"
            aria-labelledby="nested-list-subheader"
            className={classes.root}
          >
            {/* 固定メニュー */}
            <ListItemLink
              href="https://service.awesome-linus.com"
              button
            >
              <ListItemIcon>
                <HomeIcon />
              </ListItemIcon>
              <ListItemText
                primary="Service Home"
                style={{ color: '#FFFFFF' }}
              />
            </ListItemLink>

            {/* Portfolio変動メニュー */}
            <ListItem button onClick={handleClick}>
              <ListItemIcon>
                <PersonIcon />
              </ListItemIcon>
              <ListItemText
                primary="Portfolio"
                style={{ color: '#FFFFFF' }}
              />
              {listOpen ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse in={listOpen} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ModalMenuList
                  menuLists={menuLists}
                  handleClose={handleClose}
                />
              </List>
            </Collapse>

            {/* 固定メニュー */}
            <ListItemLink
              href="https://service.awesome-linus.com/contact"
              button
            >
              <ListItemIcon>
                <ContactMailIcon />
              </ListItemIcon>
              <ListItemText
                primary="Contact"
                style={{ color: '#FFFFFF' }}
              />
            </ListItemLink>

          </List>
        </div>
      </Modal>
      <Fab
        color="primary"
        aria-label="add"
        onClick={handleOpen}
        className={classes.modalOpenButton}
      >
        <AppsIcon />
      </Fab>
    </div>
  );
}

export default ModalMenu;
